// extracted by css-extract-rspack-plugin
export default {"access-denied-container":"access-denied-container-gnONzV","accessDeniedContainer":"access-denied-container-gnONzV"};